import avatarImage0 from 'images/reviewsSection/avatar1.jpeg'
import avatarImage1 from 'images/reviewsSection/avatar2.jpg'
import avatarImage2 from 'images/reviewsSection/avatar3.jpg'
import avatarImage3 from 'images/reviewsSection/avatar4.jpg'

export const reviewsSectionData = {
  linkSrc: {
    href: '#',
    role: 'button',
  },
  cards: [
    {
      imageSrc: avatarImage0,
    },
    {
      imageSrc: avatarImage1,
    },
    {
      imageSrc: avatarImage2,
    },
    {
      imageSrc: avatarImage3,
    },
  ],
}
